import { BUY_ME_A_COFFEE_URL } from "../support";

const ABOUT_PARAS = [
  "There is a place between sleep and waking where things have not yet chosen a side. A membrane. A middle that breathes. Onirya is that place.",
  "You do not come here to beat the clock. You come to stay as long as thought needs. The world's time does not enter. What enters is attention — slow, in no hurry to arrive at a conclusion.",
  "Concentration without a task. Meditation without a mantra spoken aloud. Thinking without having to answer.",
  "The game is free. Always. If this room is of use to you, and you want the lights to stay on — the server, the time of the one who builds it — you can leave a coffee.",
];

export class AboutOverlay {
  private readonly root: HTMLDivElement;
  private readonly onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape" && this.open) {
      e.preventDefault();
      this.hide();
    }
  };

  constructor(host: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "onirya-about";
    this.root.setAttribute("aria-hidden", "true");
    this.root.setAttribute("role", "dialog");
    this.root.setAttribute("aria-labelledby", "onirya-about-title");

    const card = document.createElement("article");
    card.className = "onirya-about-card";

    const title = document.createElement("h2");
    title.id = "onirya-about-title";
    title.className = "onirya-about-kicker";
    title.textContent = "Onirya";

    const close = document.createElement("button");
    close.type = "button";
    close.className = "onirya-about-close";
    close.setAttribute("aria-label", "Close");
    close.textContent = "×";
    close.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
    });

    card.append(title, close);

    for (const text of ABOUT_PARAS) {
      const p = document.createElement("p");
      p.textContent = text;
      card.append(p);
    }

    const coffee = document.createElement("a");
    coffee.className = "onirya-about-coffee";
    coffee.href = BUY_ME_A_COFFEE_URL;
    coffee.target = "_blank";
    coffee.rel = "noopener noreferrer";
    coffee.textContent = "buy me a coffee";
    card.append(coffee);

    this.root.addEventListener("pointerdown", (e) => {
      if (e.target === this.root) {
        e.preventDefault();
        this.hide();
      }
    });

    this.root.append(card);
    host.appendChild(this.root);
  }

  get open(): boolean {
    return this.root.classList.contains("is-active");
  }

  show(): void {
    this.root.parentElement?.appendChild(this.root);
    this.root.classList.add("is-active");
    this.root.setAttribute("aria-hidden", "false");
    window.addEventListener("keydown", this.onKey);
  }

  hide(): void {
    this.root.classList.remove("is-active");
    this.root.setAttribute("aria-hidden", "true");
    window.removeEventListener("keydown", this.onKey);
  }

  remove(): void {
    this.hide();
    this.root.remove();
  }
}
